import { useMutation } from '@tanstack/react-query';

import { LoginVerifyCodeData } from '../../../../../types/requests';
import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { postVerifyCode } from '../../requests/postVerifyCode';

export const useVerifyCode = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: LoginVerifyCodeData) =>
      postVerifyCode(constructPost, data),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Failed to verify code.')),
  });
  return { verifyCode: mutateAsync, ...rest };
};
